<template>
  <div class="content">
    <h1>404</h1>
    <div class="error-desk">
      <h2>{{ label.get("ops_page_not_found") }}</h2>
      <p>{{ label.get("the_page_doesnt_exist_description") }}</p>
    </div>
    <button class="back-btn" @click="goBack">
      {{ label.get("go_back") }}
    </button>
  </div>
</template>

<script>
export default {
  name: "NotFoundComponent",
  mounted() {
    const initialLoader = document.getElementById("initial-loader");
    if (initialLoader !== undefined && initialLoader !== null) {
      initialLoader.remove();
    }
  },
  methods: {
    goBack() {
      this.$router.go(-2);
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;

  h1 {
    font-family: "Roboto", sans-serif;
    font-size: 96px;
    line-height: 112px;
    margin-bottom: 32px;
    font-weight: 500;
    color: #262626;
  }

  .error-desk {
    text-align: center;
  }

  h2 {
    font-family: "Roboto", sans-serif;
    font-size: 28px;
    line-height: 33px;
    font-weight: 500;
    margin-bottom: 9px;
    color: #262626;
  }

  p {
    font-size: 18px;
    line-height: 32px;
    color: #999;
    font-family: "Roboto", sans-serif;
    margin-bottom: 62px;
    font-weight: 400;
  }

  .back-btn {
    width: 160px;
    font-size: 18px;
    line-height: 20px;
    color: #fff;
    text-transform: uppercase;
    font-family: "Roboto", sans-serif;
    padding: 10px;
    text-align: center;
    background-color: #00b9cb;
    border-radius: 0;
    border: 0;
    font-weight: 400;
    margin-bottom: 0;
  }
}
</style>
